import { h } from "@stencil/core";

/* eslint-disable max-len */
export const FilterMenu = () => (
    <svg viewBox='0 0 48 48' role='img' fill='currentColor'>
        <path d='M10.0278 8.99902H37.9698L26.9998 23.9922V32.997L20.9998 38.997V23.9943L10.0278 8.99902Z' />
        <path d='M26.4998 43C27.8805 43 28.9998 41.8807 28.9998 40.5C28.9998 39.1193 27.8805 38 26.4998 38C25.1191 38 23.9998 39.1193 23.9998 40.5C23.9998 41.8807 25.1191 43 26.4998 43Z' />
        <path d='M33.4998 43C34.8805 43 35.9998 41.8807 35.9998 40.5C35.9998 39.1193 34.8805 38 33.4998 38C32.1191 38 30.9998 39.1193 30.9998 40.5C30.9998 41.8807 32.1191 43 33.4998 43Z' />
        <path d='M42.9998 40.5C42.9998 41.8807 41.8805 43 40.4998 43C39.1191 43 37.9998 41.8807 37.9998 40.5C37.9998 39.1193 39.1191 38 40.4998 38C41.8805 38 42.9998 39.1193 42.9998 40.5Z' />
    </svg>
);
